import React, { Component } from 'react'
//import Navbar from 'react-bootstrap/Navbar'
//import Form from 'react-bootstrap/Form'
//import Button from 'react-bootstrap/Button'
import ListItem from './ListItem'
import axios from 'axios'
import AdminAgreementTools from '../../commonComponents/AdminAgreementTools'
import { ADMIN_ACCOUNT } from '../../commonComponents/adminActions'

class List extends Component {
	constructor(props) {
		super(props)
		this.state = {files: []}
	}
	render() {
		return <>
			{this.props.account === ADMIN_ACCOUNT ?
				<AdminAgreementTools files={this.state.files} /> : null}
			{this.state.files.map((file, index) => {
				return <ListItem
					key={index}
					totalNumber={file.scoringTimes}
					fileName={file.name}
					selectItem={(t) => {
						//console.log('id:', file.psgFileId, 'times:', t)
						window.location.href = '#/scoring/' + file.psgFileId + '/' + t
					}}
					psgFileId={file.psgFileId}
					paused={file.paused} />
			})}
		</>
	}
	async componentDidMount() {
		let filesResult = await axios.post('/ajax_list_files', {})
		if (!filesResult.data.success) {
			alert(filesResult.data.msg)
			window.history.go(0)
			return
		}
		//console.log(filesResult.data.psgInfo)
		let showdata = []
		for (let i = 0; i < filesResult.data.psgInfo.length; i++) {
			if (filesResult.data.psgInfo[i].name[0] !== '#') {
				showdata.push(filesResult.data.psgInfo[i])
			}
		}
		//console.log(showdata)
		this.setState({ files: showdata })
		
	}
}

export default List
